export const LEARN_DONE_KEY = 'tk_learn_done';
export const LEARN_PROMPT_KEY = 'tk_learn_prompt_dismissed';

function readJson(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function getCompletedLessonIds() {
  const value = readJson(LEARN_DONE_KEY, []);
  return Array.isArray(value) ? value.filter((id) => typeof id === 'string') : [];
}

export function isLessonComplete(lessonId) {
  return getCompletedLessonIds().includes(lessonId);
}

export function markLessonComplete(lessonId) {
  if (!lessonId) return getCompletedLessonIds();
  const next = Array.from(new Set([...getCompletedLessonIds(), lessonId]));
  try {
    localStorage.setItem(LEARN_DONE_KEY, JSON.stringify(next));
  } catch {
    /* private mode */
  }
  return next;
}

export function isLearnPromptDismissed() {
  try {
    return localStorage.getItem(LEARN_PROMPT_KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissLearnPrompt() {
  try {
    localStorage.setItem(LEARN_PROMPT_KEY, '1');
  } catch {
    /* private mode */
  }
}
